import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { TrackerProvider } from '@dpdgroupuk/react-event-tracker';
import { ThemeProvider } from '@mui/material/styles';

import theme from './components/styles/theme';
import store from './store';
import ErrorBoundary from './components/ErrorBoundary';
import OverlayProvider from './components/Overlay/Provider';
import SomethingWentWrong from './components/SomethingWentWrong';
import Sentry from './services/sentry';
import { tracker } from './utils/eventTracker';
import { ModalProvider } from './components/ModalControlled/ModalProvider';
import AppRouter from './routes';

const App = () => (
  <Provider store={store}>
    <TrackerProvider tracker={tracker}>
      <ThemeProvider theme={theme}>
        <ModalProvider>
          <OverlayProvider>
            <ErrorBoundary component={SomethingWentWrong} sentry={Sentry}>
              <RouterProvider router={AppRouter} />
            </ErrorBoundary>
          </OverlayProvider>
        </ModalProvider>
      </ThemeProvider>
    </TrackerProvider>
  </Provider>
);

export default App;
